import { PreviewToken } from '../../common/data-preview';
import { ISettings } from '../../common/settings-interface';
import { SettingsKey } from '../../common/settings-key';
import { AqiStandardId, DatasourceId, NetworkId } from '../../types';

export class MapPageUrlSettings implements ISettings {
  private readonly queryParams: URLSearchParams;

  constructor(
    public readonly networkId: NetworkId,
    public readonly datasourceId: DatasourceId | null,
    readonly searchString: string
  ) {
    this.queryParams = new URLSearchParams(searchString);
  }

  get latitude(): number | null {
    return this.queryParams.has(SettingsKey.latitude) ? parseFloat(this.queryParams.get(SettingsKey.latitude)!) : null;
  }

  get longitude(): number | null {
    return this.queryParams.has(SettingsKey.longitude)
      ? parseFloat(this.queryParams.get(SettingsKey.longitude)!)
      : null;
  }

  get zoom(): number | null {
    return this.queryParams.has(SettingsKey.zoom) ? parseFloat(this.queryParams.get(SettingsKey.zoom)!) : null;
  }

  get searchedLatitude(): number | null {
    return this.queryParams.has(SettingsKey.searchedLatitude)
      ? parseFloat(this.queryParams.get(SettingsKey.searchedLatitude)!)
      : null;
  }

  get searchedLongitude(): number | null {
    return this.queryParams.has(SettingsKey.searchedLongitude)
      ? parseFloat(this.queryParams.get(SettingsKey.searchedLongitude)!)
      : null;
  }

  get preview(): PreviewToken | null {
    return this.queryParams.has(SettingsKey.preview)
      ? (this.queryParams.get(SettingsKey.preview)! as PreviewToken)
      : null;
  }

  get aqiStdId(): AqiStandardId | null {
    return this.queryParams.has(SettingsKey.aqiStdId)
      ? (this.queryParams.get(SettingsKey.aqiStdId)! as AqiStandardId)
      : null;
  }

  get disableTour(): boolean | null {
    return this.queryParams.has(SettingsKey.disableTour);
  }

  isEmpty(): boolean {
    return Object.values(SettingsKey).every((key) => !this.queryParams.has(key));
  }
}
